import axios from 'axios';
import { Consultancy } from '../dtos/consultancy';
import { getApiV1Url } from '../utils/api';

export async function saveConsultancy(consultancy: Consultancy): Promise<Consultancy> {
  const { data } = await axios.post<Consultancy>(`${getApiV1Url()}/consultancies`, consultancy);

  return data;
}
